// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/agreements/agreements.proto (package aurora.core.apiengine.agreementsv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { RoundingRule } from "../../../../consts/loanconsts_pb";
import { file_consts_loanconsts } from "../../../../consts/loanconsts_pb";
import type { Side } from "../../../../consts/commonconsts_pb";
import { file_consts_commonconsts } from "../../../../consts/commonconsts_pb";
import type { SettlementType } from "../../../../consts/settlementconsts_pb";
import { file_consts_settlementconsts } from "../../../../consts/settlementconsts_pb";
import type { AgreementStatus, CollateralMethod, CollateralType, DeliveryType, SettlementSystem, TermType } from "../../../../consts/agreementconsts_pb";
import { file_consts_agreementconsts } from "../../../../consts/agreementconsts_pb";
import type { Currency } from "../../../../common/protos/types_pb";
import { file_common_protos_types } from "../../../../common/protos/types_pb";
import { file_modules_apiengine_services_agreements_agreements_rules } from "./agreements_rules_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/agreements/agreements.proto.
 */
export const file_modules_apiengine_services_agreements_agreements: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_consts_loanconsts, file_consts_commonconsts, file_consts_settlementconsts, file_consts_agreementconsts, file_common_protos_types, file_modules_apiengine_services_agreements_agreements_rules]);

/**
 * Create-Agreement Request
 *
 * @generated from message aurora.core.apiengine.agreementsv1.CreateAgreementRequest
 */
export type CreateAgreementRequest = Message<"aurora.core.apiengine.agreementsv1.CreateAgreementRequest"> & {
  /**
   * Agreements require a short name that can be used for both display in the order book and when creating new orders.
   * Short names must be unique amongst your agreements and must be 25 characters or less. Names are case sensitive.
   * Spaces are supported but not recommended.
   *
   * @generated from field: string short_name = 1;
   */
  shortName: string;

  /**
   * This will be the Provable assigned company_id. See the Company endpoint for more details.
   *
   * @generated from field: string counterparty_id = 2;
   */
  counterpartyId: string;

  /**
   * The type of settlement that will be associated with new trades in this agreement BILATERAL, NSCC, OCC
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 3;
   */
  settlementType: SettlementType;

  /**
   * The rounding rule to be used by both parties when calculating the contract price
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 4;
   */
  roundingRule: RoundingRule;

  /**
   * The Margin or Collateral rate to be used by both parties when calculating the contract price and value. (ie. 102%)
   *
   * @generated from field: string collateral_rate = 5;
   */
  collateralRate: string;

  /**
   * The side you will be taking on orders associated with this agreement.
   *
   * @generated from field: aurora.core.consts.common.Side side = 6;
   */
  side: Side;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralType collateral_type = 7;
   */
  collateralType: CollateralType;

  /**
   * @generated from field: aurora.core.common.protos.Currency pricing_currency = 8;
   */
  pricingCurrency: Currency;

  /**
   * @generated from field: aurora.core.common.protos.Currency billing_currency = 9;
   */
  billingCurrency: Currency;

  /**
   * @generated from field: optional aurora.core.common.protos.Currency collateral_currency = 23;
   */
  collateralCurrency?: Currency;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralMethod collateral_method = 10;
   */
  collateralMethod: CollateralMethod;

  /**
   * @generated from field: string dividend_required = 11;
   */
  dividendRequired: string;

  /**
   * @generated from field: aurora.core.consts.agreements.TermType term_type = 12;
   */
  termType: TermType;

  /**
   * @generated from field: optional string term_start_date = 13;
   */
  termStartDate?: string;

  /**
   * @generated from field: optional string term_end_date = 14;
   */
  termEndDate?: string;

  /**
   * Balance Target can be added by each party for their own purposes, not visible to the counterparty
   *
   * @generated from field: optional string balance_target = 15;
   */
  balanceTarget?: string;

  /**
   * Balance Target Variance can be added by each party for their own purposes, not visible to the counterparty
   *
   * @generated from field: optional string balance_target_variance = 16;
   */
  balanceTargetVariance?: string;

  /**
   * @generated from field: optional string rwa_bucket = 17;
   */
  rwaBucket?: string;

  /**
   * @generated from field: optional aurora.core.consts.agreements.SettlementSystem settlement_system = 18;
   */
  settlementSystem?: SettlementSystem;

  /**
   * @generated from field: optional string booking_account = 20;
   */
  bookingAccount?: string;

  /**
   * @generated from field: optional string trade_type = 21;
   */
  tradeType?: string;

  /**
   * @generated from field: optional string profit_center = 22;
   */
  profitCenter?: string;

  /**
   * @generated from field: aurora.core.consts.agreements.DeliveryType delivery_type = 24;
   */
  deliveryType: DeliveryType;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.CreateAgreementRequest.
 * Use `create(CreateAgreementRequestSchema)` to create a new message.
 */
export const CreateAgreementRequestSchema: GenMessage<CreateAgreementRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 0);

/**
 * Create-Agreement Response
 *
 * @generated from message aurora.core.apiengine.agreementsv1.CreateAgreementResponse
 */
export type CreateAgreementResponse = Message<"aurora.core.apiengine.agreementsv1.CreateAgreementResponse"> & {
  /**
   * @generated from field: aurora.core.apiengine.agreementsv1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.CreateAgreementResponse.
 * Use `create(CreateAgreementResponseSchema)` to create a new message.
 */
export const CreateAgreementResponseSchema: GenMessage<CreateAgreementResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 1);

/**
 * Approve-Agreement Request
 *
 * @generated from message aurora.core.apiengine.agreementsv1.ApproveAgreementRequest
 */
export type ApproveAgreementRequest = Message<"aurora.core.apiengine.agreementsv1.ApproveAgreementRequest"> & {
  /**
   * ID of the agreement
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Agreements require a short name that can be used for both display in the order book and when creating new orders.
   * Short names must be unique amongst your agreements and must be 25 characters or less.
   * Spaces are supported but not recommended.
   *
   * @generated from field: string short_name = 2;
   */
  shortName: string;

  /**
   * Balance Target can be added by each party for their own purposes, not visible to the counterparty
   *
   * @generated from field: optional string balance_target = 4;
   */
  balanceTarget?: string;

  /**
   * Balance Target Variance can be added by each party for their own purposes, not visible to the counterparty
   *
   * @generated from field: optional string balance_target_variance = 5;
   */
  balanceTargetVariance?: string;

  /**
   * A settlement system can be chosen (PROVABLE_MARKET, LOANET, LOANET_SFT, SPIRE, PROP), not visible to the counterparty.
   *
   * @generated from field: optional aurora.core.consts.agreements.SettlementSystem settlement_system = 6;
   */
  settlementSystem?: SettlementSystem;

  /**
   * Booking Account added by each party, visible to the counterparty
   *
   * @generated from field: optional string booking_account = 7;
   */
  bookingAccount?: string;

  /**
   * @generated from field: optional string profit_center = 8;
   */
  profitCenter?: string;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.ApproveAgreementRequest.
 * Use `create(ApproveAgreementRequestSchema)` to create a new message.
 */
export const ApproveAgreementRequestSchema: GenMessage<ApproveAgreementRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 2);

/**
 * Approve-Agreement Response
 *
 * @generated from message aurora.core.apiengine.agreementsv1.ApproveAgreementResponse
 */
export type ApproveAgreementResponse = Message<"aurora.core.apiengine.agreementsv1.ApproveAgreementResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.ApproveAgreementResponse.
 * Use `create(ApproveAgreementResponseSchema)` to create a new message.
 */
export const ApproveAgreementResponseSchema: GenMessage<ApproveAgreementResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 3);

/**
 * Reject-Agreement Request
 *
 * @generated from message aurora.core.apiengine.agreementsv1.RejectAgreementRequest
 */
export type RejectAgreementRequest = Message<"aurora.core.apiengine.agreementsv1.RejectAgreementRequest"> & {
  /**
   * ID of the agreement
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.RejectAgreementRequest.
 * Use `create(RejectAgreementRequestSchema)` to create a new message.
 */
export const RejectAgreementRequestSchema: GenMessage<RejectAgreementRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 4);

/**
 * Reject-Agreement Response
 *
 * @generated from message aurora.core.apiengine.agreementsv1.RejectAgreementResponse
 */
export type RejectAgreementResponse = Message<"aurora.core.apiengine.agreementsv1.RejectAgreementResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.RejectAgreementResponse.
 * Use `create(RejectAgreementResponseSchema)` to create a new message.
 */
export const RejectAgreementResponseSchema: GenMessage<RejectAgreementResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 5);

/**
 * Modify-Agreement Request
 *
 * @generated from message aurora.core.apiengine.agreementsv1.ModifyAgreementRequest
 */
export type ModifyAgreementRequest = Message<"aurora.core.apiengine.agreementsv1.ModifyAgreementRequest"> & {
  /**
   * The reference for the agreement you wish to modify
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Agreements require a short name that can be used for both display in the order book and when creating new orders. Short names must be unique amongst your agreements and must be 25 characters or less. Spaces are supported but not recommended.
   *
   * @generated from field: string short_name = 2;
   */
  shortName: string;

  /**
   * Bilateral, NSCC, OCC
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 3;
   */
  settlementType: SettlementType;

  /**
   * The rounding rule to be used by both parties when calculating the contract price
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 4;
   */
  roundingRule: RoundingRule;

  /**
   * Updated Margin / Collateral Rate
   *
   * @generated from field: string collateral_rate = 5;
   */
  collateralRate: string;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralType collateral_type = 6;
   */
  collateralType: CollateralType;

  /**
   * @generated from field: aurora.core.common.protos.Currency pricing_currency = 7;
   */
  pricingCurrency: Currency;

  /**
   * @generated from field: aurora.core.common.protos.Currency billing_currency = 8;
   */
  billingCurrency: Currency;

  /**
   * @generated from field: optional aurora.core.common.protos.Currency collateral_currency = 24;
   */
  collateralCurrency?: Currency;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralMethod collateral_method = 9;
   */
  collateralMethod: CollateralMethod;

  /**
   * @generated from field: string dividend_required = 10;
   */
  dividendRequired: string;

  /**
   * @generated from field: aurora.core.consts.agreements.TermType term_type = 11;
   */
  termType: TermType;

  /**
   * @generated from field: optional string term_start_date = 12;
   */
  termStartDate?: string;

  /**
   * @generated from field: optional string term_end_date = 13;
   */
  termEndDate?: string;

  /**
   * @generated from field: optional string balance_target = 14;
   */
  balanceTarget?: string;

  /**
   * @generated from field: optional string balance_target_variance = 15;
   */
  balanceTargetVariance?: string;

  /**
   * @generated from field: optional aurora.core.consts.agreements.SettlementSystem settlement_system = 19;
   */
  settlementSystem?: SettlementSystem;

  /**
   * @generated from field: optional string rwa_bucket = 18;
   */
  rwaBucket?: string;

  /**
   * @generated from field: optional string booking_account = 21;
   */
  bookingAccount?: string;

  /**
   * @generated from field: optional string trade_type = 22;
   */
  tradeType?: string;

  /**
   * @generated from field: optional string profit_center = 23;
   */
  profitCenter?: string;

  /**
   * @generated from field: aurora.core.consts.agreements.DeliveryType delivery_type = 25;
   */
  deliveryType: DeliveryType;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.ModifyAgreementRequest.
 * Use `create(ModifyAgreementRequestSchema)` to create a new message.
 */
export const ModifyAgreementRequestSchema: GenMessage<ModifyAgreementRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 6);

/**
 * Modify-Agreement Response
 *
 * @generated from message aurora.core.apiengine.agreementsv1.ModifyAgreementResponse
 */
export type ModifyAgreementResponse = Message<"aurora.core.apiengine.agreementsv1.ModifyAgreementResponse"> & {
  /**
   * @generated from field: aurora.core.apiengine.agreementsv1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.ModifyAgreementResponse.
 * Use `create(ModifyAgreementResponseSchema)` to create a new message.
 */
export const ModifyAgreementResponseSchema: GenMessage<ModifyAgreementResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 7);

/**
 * Cancel-Agreement Request
 *
 * @generated from message aurora.core.apiengine.agreementsv1.CancelAgreementRequest
 */
export type CancelAgreementRequest = Message<"aurora.core.apiengine.agreementsv1.CancelAgreementRequest"> & {
  /**
   * The reference for the agreement to be closed
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.CancelAgreementRequest.
 * Use `create(CancelAgreementRequestSchema)` to create a new message.
 */
export const CancelAgreementRequestSchema: GenMessage<CancelAgreementRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 8);

/**
 * Cancel-Agreement Response
 *
 * @generated from message aurora.core.apiengine.agreementsv1.CancelAgreementResponse
 */
export type CancelAgreementResponse = Message<"aurora.core.apiengine.agreementsv1.CancelAgreementResponse"> & {
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.CancelAgreementResponse.
 * Use `create(CancelAgreementResponseSchema)` to create a new message.
 */
export const CancelAgreementResponseSchema: GenMessage<CancelAgreementResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 9);

/**
 * List-Agreements Request
 *
 * @generated from message aurora.core.apiengine.agreementsv1.ListAgreementsRequest
 */
export type ListAgreementsRequest = Message<"aurora.core.apiengine.agreementsv1.ListAgreementsRequest"> & {
  /**
   * The list of status of the agreements you wish to query.
   *
   * @generated from field: repeated aurora.core.consts.agreements.AgreementStatus statuses = 1;
   */
  statuses: AgreementStatus[];

  /**
   * The side you are of the agreement Provable Markets order reference
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 2;
   */
  side?: Side;

  /**
   * @generated from field: repeated string counterparty_ids = 3;
   */
  counterpartyIds: string[];

  /**
   * Cusip or Ticker of instrument
   *
   * @generated from field: optional string eligible_instrument = 4;
   */
  eligibleInstrument?: string;

  /**
   * @generated from field: repeated string booking_accounts = 5;
   */
  bookingAccounts: string[];

  /**
   * @generated from field: repeated string counterparty_booking_accounts = 6;
   */
  counterpartyBookingAccounts: string[];

  /**
   * @generated from field: repeated string trade_types = 7;
   */
  tradeTypes: string[];

  /**
   * @generated from field: repeated aurora.core.common.protos.Currency collateral_currencies = 8;
   */
  collateralCurrencies: Currency[];

  /**
   * @generated from field: repeated aurora.core.consts.agreements.DeliveryType delivery_types = 9;
   */
  deliveryTypes: DeliveryType[];
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.ListAgreementsRequest.
 * Use `create(ListAgreementsRequestSchema)` to create a new message.
 */
export const ListAgreementsRequestSchema: GenMessage<ListAgreementsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 10);

/**
 * List-Agreements Response
 *
 * @generated from message aurora.core.apiengine.agreementsv1.ListAgreementsResponse
 */
export type ListAgreementsResponse = Message<"aurora.core.apiengine.agreementsv1.ListAgreementsResponse"> & {
  /**
   * List of agreements
   *
   * @generated from field: repeated aurora.core.apiengine.agreementsv1.Agreement agreements = 1;
   */
  agreements: Agreement[];
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.ListAgreementsResponse.
 * Use `create(ListAgreementsResponseSchema)` to create a new message.
 */
export const ListAgreementsResponseSchema: GenMessage<ListAgreementsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 11);

/**
 * @generated from message aurora.core.apiengine.agreementsv1.GetAgreementRequest
 */
export type GetAgreementRequest = Message<"aurora.core.apiengine.agreementsv1.GetAgreementRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.GetAgreementRequest.
 * Use `create(GetAgreementRequestSchema)` to create a new message.
 */
export const GetAgreementRequestSchema: GenMessage<GetAgreementRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 12);

/**
 * @generated from message aurora.core.apiengine.agreementsv1.GetAgreementResponse
 */
export type GetAgreementResponse = Message<"aurora.core.apiengine.agreementsv1.GetAgreementResponse"> & {
  /**
   * @generated from field: aurora.core.apiengine.agreementsv1.Agreement agreement = 1;
   */
  agreement?: Agreement;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.GetAgreementResponse.
 * Use `create(GetAgreementResponseSchema)` to create a new message.
 */
export const GetAgreementResponseSchema: GenMessage<GetAgreementResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 13);

/**
 * OrderAgreement is a limited agreement object included in order events.
 *
 * @generated from message aurora.core.apiengine.agreementsv1.OrderAgreement
 */
export type OrderAgreement = Message<"aurora.core.apiengine.agreementsv1.OrderAgreement"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string short_name = 2;
   */
  shortName: string;

  /**
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 3;
   */
  settlementType: SettlementType;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralType collateral_type = 4;
   */
  collateralType: CollateralType;

  /**
   * @generated from field: aurora.core.common.protos.Currency pricing_currency = 5;
   */
  pricingCurrency: Currency;

  /**
   * @generated from field: aurora.core.common.protos.Currency billing_currency = 6;
   */
  billingCurrency: Currency;

  /**
   * @generated from field: optional aurora.core.common.protos.Currency collateral_currency = 7;
   */
  collateralCurrency?: Currency;

  /**
   * @generated from field: string dividend_required = 8;
   */
  dividendRequired: string;

  /**
   * @generated from field: optional string booking_account = 9;
   */
  bookingAccount?: string;

  /**
   * @generated from field: aurora.core.consts.agreements.DeliveryType delivery_type = 10;
   */
  deliveryType: DeliveryType;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.OrderAgreement.
 * Use `create(OrderAgreementSchema)` to create a new message.
 */
export const OrderAgreementSchema: GenMessage<OrderAgreement> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 14);

/**
 * @generated from message aurora.core.apiengine.agreementsv1.Agreement
 */
export type Agreement = Message<"aurora.core.apiengine.agreementsv1.Agreement"> & {
  /**
   * A unique reference for the agreement assigned by Provable Markets
   *
   * @generated from field: string id = 7;
   */
  id: string;

  /**
   * The short name your company has assigned to this agreement
   *
   * @generated from field: string short_name = 1;
   */
  shortName: string;

  /**
   * Your company's side on the agreement
   *
   * @generated from field: aurora.core.consts.common.Side side = 2;
   */
  side: Side;

  /**
   * The Provable assigned company_id of the counterparty in the agreement
   *
   * @generated from field: string counterparty_id = 3;
   */
  counterpartyId: string;

  /**
   * The settlement type associated with the agreement. See appendix for more details
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 4;
   */
  settlementType: SettlementType;

  /**
   * The rounding rules associated with the agreement
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 5;
   */
  roundingRule: RoundingRule;

  /**
   * Collateral Rate
   *
   * @generated from field: string collateral_rate = 6;
   */
  collateralRate: string;

  /**
   * The status of the agreement
   *
   * @generated from field: aurora.core.consts.agreements.AgreementStatus status = 9;
   */
  status: AgreementStatus;

  /**
   * The user who initially created the agreement
   *
   * @generated from field: string proposer_user = 10;
   */
  proposerUser: string;

  /**
   * @generated from field: aurora.core.consts.common.Side proposed_by_side = 15;
   */
  proposedBySide: Side;

  /**
   * The user who approved or rejected the agreement
   *
   * @generated from field: optional string responder_user = 11;
   */
  responderUser?: string;

  /**
   * After modifications are accepted, the sequential count changes to the next value. Note: Short Name changes do not result in a new version. Just shared element updates do.
   *
   * @generated from field: int64 version = 12;
   */
  version: bigint;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralType collateral_type = 13;
   */
  collateralType: CollateralType;

  /**
   * @generated from field: aurora.core.common.protos.Currency pricing_currency = 14;
   */
  pricingCurrency: Currency;

  /**
   * @generated from field: aurora.core.common.protos.Currency billing_currency = 16;
   */
  billingCurrency: Currency;

  /**
   * @generated from field: optional aurora.core.common.protos.Currency collateral_currency = 33;
   */
  collateralCurrency?: Currency;

  /**
   * @generated from field: aurora.core.consts.agreements.CollateralMethod collateral_method = 17;
   */
  collateralMethod: CollateralMethod;

  /**
   * @generated from field: string dividend_required = 18;
   */
  dividendRequired: string;

  /**
   * @generated from field: aurora.core.consts.agreements.TermType term_type = 19;
   */
  termType: TermType;

  /**
   * @generated from field: optional string term_start_date = 20;
   */
  termStartDate?: string;

  /**
   * @generated from field: optional string term_end_date = 21;
   */
  termEndDate?: string;

  /**
   * @generated from field: optional string balance_target = 22;
   */
  balanceTarget?: string;

  /**
   * @generated from field: optional string balance_target_variance = 23;
   */
  balanceTargetVariance?: string;

  /**
   * @generated from field: optional string rwa_bucket = 24;
   */
  rwaBucket?: string;

  /**
   * @generated from field: optional aurora.core.consts.agreements.SettlementSystem settlement_system = 25;
   */
  settlementSystem?: SettlementSystem;

  /**
   * Datetime that agreement was initially created - time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 27;
   */
  createdAt: string;

  /**
   * Datetime that agreement was approved by the second party - time in RFC3339 with millisecond precision
   *
   * @generated from field: optional string approved_at = 28;
   */
  approvedAt?: string;

  /**
   * @generated from field: optional string booking_account = 29;
   */
  bookingAccount?: string;

  /**
   * @generated from field: optional string counterparty_booking_account = 30;
   */
  counterpartyBookingAccount?: string;

  /**
   * @generated from field: optional string trade_type = 31;
   */
  tradeType?: string;

  /**
   * @generated from field: optional string profit_center = 32;
   */
  profitCenter?: string;

  /**
   * @generated from field: aurora.core.consts.agreements.DeliveryType delivery_type = 34;
   */
  deliveryType: DeliveryType;
};

/**
 * Describes the message aurora.core.apiengine.agreementsv1.Agreement.
 * Use `create(AgreementSchema)` to create a new message.
 */
export const AgreementSchema: GenMessage<Agreement> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_agreements_agreements, 15);

/**
 * Methods to create and modify agreements
 *
 * @generated from service aurora.core.apiengine.agreementsv1.AgreementService
 */
export const AgreementService: GenService<{
  /**
   * CreateAgreement can be used tc create an agreement
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.CreateAgreement
   */
  createAgreement: {
    methodKind: "unary";
    input: typeof CreateAgreementRequestSchema;
    output: typeof CreateAgreementResponseSchema;
  },
  /**
   * ApproveAgreement can be used to approve a drafted agreement
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.ApproveAgreement
   */
  approveAgreement: {
    methodKind: "unary";
    input: typeof ApproveAgreementRequestSchema;
    output: typeof ApproveAgreementResponseSchema;
  },
  /**
   * RejectAgreement can be used to reject a drafted agreement
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.RejectAgreement
   */
  rejectAgreement: {
    methodKind: "unary";
    input: typeof RejectAgreementRequestSchema;
    output: typeof RejectAgreementResponseSchema;
  },
  /**
   * ModifyAgreement can be used to create a new version of an agreement
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.ModifyAgreement
   */
  modifyAgreement: {
    methodKind: "unary";
    input: typeof ModifyAgreementRequestSchema;
    output: typeof ModifyAgreementResponseSchema;
  },
  /**
   *  CancelAgreement can be used to cancel a drafted or active agreement
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.CancelAgreement
   */
  cancelAgreement: {
    methodKind: "unary";
    input: typeof CancelAgreementRequestSchema;
    output: typeof CancelAgreementResponseSchema;
  },
  /**
   *  ListAgreements can be used to query agreements
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.ListAgreements
   */
  listAgreements: {
    methodKind: "unary";
    input: typeof ListAgreementsRequestSchema;
    output: typeof ListAgreementsResponseSchema;
  },
  /**
   *  GetAgreement can be used to get an agreement
   *
   * @generated from rpc aurora.core.apiengine.agreementsv1.AgreementService.GetAgreement
   */
  getAgreement: {
    methodKind: "unary";
    input: typeof GetAgreementRequestSchema;
    output: typeof GetAgreementResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_agreements_agreements, 0);

